import {Component, EventEmitter, Input, LOCALE_ID, OnInit, Output} from '@angular/core';
import { ClarityModule } from "@clr/angular";
import { FormBuilder, FormControl, FormGroup, ReactiveFormsModule } from "@angular/forms";
import { DatePipe, JsonPipe, NgIf } from "@angular/common";
import { AlertService, IAlertType, InvoicesStoreService } from "../../../../_shared/services";

import moment from "moment";
import { environment as env } from "../../../../../environments/environment";
import {ClarityIcons, floppyIcon} from "@cds/core/icon";

@Component({
  selector: 'app-invoice-duedate',
  standalone: true,
  imports: [
    ClarityModule,
    ReactiveFormsModule,
    NgIf,
    DatePipe,
    JsonPipe
  ],
  templateUrl: './invoice-duedate.component.html',
  styleUrl: './invoice-duedate.component.sass',
  providers: [{ provide: LOCALE_ID, useValue: 'de'}]
})
export class InvoiceDuedateComponent implements OnInit {
  dateForm = new FormGroup({ newDueDate: new FormControl()});
  devMode: boolean;

  @Input() dueDate: string = '';
  @Input() praefix: string = '';
  @Input() invoiceId: string = '';
  @Output() updatedDate = new EventEmitter();

  constructor(
    private invss: InvoicesStoreService,
    private alertDispatcher: AlertService,
    private fb: FormBuilder
  ) {
    this.devMode = env.stages.dev;
    ClarityIcons.addIcons(floppyIcon);
  }

  ngOnInit(): void {
    this.initForm()
  }

  initForm() {
    this.dateForm = this.fb.group({
      newDueDate: moment(this.dueDate).format("DD.MM.yyyy"),
    });
  }

  updateDueDate() {
    this.invss.updateDueDate(this.praefix + '.' + this.invoiceId, this.dateForm.value)
      .subscribe({
        next: data => {
            this.updatedDate.emit(true);
        },
        complete: () => {
          this.alertDispatcher.alertConfig.message = 'Rechnungsdatum wurde aktualisiert.';
          this.alertDispatcher.alertConfig.clrAlertType = IAlertType.SUCCESS;
        },
        error: (error) => {
          this.alertDispatcher.show({
            message: 'Fehler beim Eintragen der Fälligkeit: ' + error,
            clrAlertType: IAlertType.DANGER
          }, 5000);
          return}
      });
  }
}

